import { saveFirmPanActions } from "./action";

const initialState = {
  PanFirmVerify: null,
  error: "",
};

const savePanNumFirmReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveFirmPanActions.SAVE_FIRM_PAN_DETAILS_SUCCESS:
      return {
        ...state,
        // accountNoVerify: action.payload.data,
      };
    case saveFirmPanActions.SAVE_FIRM_PAN_DETAILS_ERROR:
      return {
        ...state,
        PanFirmVerify: [],
        error: "",
      };

    default:
      return state;
  }
};

export default savePanNumFirmReducer;
